export enum ButtonVariant {
  OUTLINE = 'outline',
  CONTAINED = 'contained',
  SUBMIT = 'submit',
}
